<template>
  <div id="modal-detail-historical-internal-memo-pk">
    <div class="container-fluid">
      <div v-if="isLoading" class="row mb-3">
        <!-- Skeleton loader, misalnya tampilkan placeholder -->
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <!-- Tambahkan skeleton untuk seluruh konten yang memerlukan data -->
      </div>

      <div class="mt-1 pt-3" v-else>
        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">Internal Memo Pengajuan Khusus</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-md-3 mt-3">
                <label> Title: <span class="text-danger">*</span> </label>
                <p>
                  {{ detail?.name }}
                </p>
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>IM Number: <span class="text-danger">*</span></label>
                <p>
                  {{ detail?.im_number }}
                </p>
              </div>

              <div class="col-md-6 col-md-3 mt-3">
                <label>Category: <span class="text-danger">*</span></label>
                <p>
                  {{ detail?.im_category }}
                </p>
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>Year: <span class="text-danger">*</span></label>
                <p>
                  {{ detail?.im_year }}
                </p>
              </div>

              <div class="col-md-12 col-md-6 mt-3">
                <label>Department:</label>
                <p>
                  {{ detail?.departments[0]?.department_name }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">Internal Memo Files</div>
          <div class="card-body">
            <div class="row mb-3" v-for="(item, index) in rowData?.attachments" :key="`${item}`">
              <div class="card">
                <div class="card-body">
                  <label>
                    {{ index === 0 ? 'Internal Memo (DOCX/PDF)' : `Lampiran ${index} (DOCX/PDF)` }}
                  </label>
                  <p>
                    <a class="ml-0" v-if="rowData?.attachments?.[index]?.url" :href="rowData?.attachments?.[index]?.url || ''" target="_blank">
                      {{ rowData?.attachments?.[index]?.name ? rowData?.attachments?.[index]?.name : rowData?.attachments?.[index]?.filename }}
                    </a>
                    <span v-else>
                      {{ rowData?.attachments?.[index]?.name ? rowData?.attachments?.[index]?.name : rowData?.attachments?.[index]?.filename }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">Additional Budget</div>
          <div class="card-body">
            <div>
              <button type="button" class="btn btn-primary">
                {{ rowData?.im_budget?.transaction_type }}
              </button>
            </div>
            <!--            <div class="row">
              <div class="col-md-6 col-md-3">
                <label>Budget Plan</label>
                <p>
                  {{ rowData?.im_budget?.taskDetail?.plan_title }}
                </p>
                <input
                  type="text"
                  class="form-control"
                  :value="rowData?.im_budget?.taskDetail?.plan_title"
                  name="Category"
                  hidden="hidden"
                  disabled
                />
              </div>
            </div>-->

            <!--            <div class="row">
              <div class="col-md-6 col-md-3">
                <label>Budget Plan</label>
                <input type="text" class="form-control" v-model="payload.plan_id" name="Category" hidden="hidden" disabled />
                <input type="text" class="form-control" v-model="planTitle" name="planTitle" disabled />
                &lt;!&ndash;
                <v-select
                :options="listDepartement"
                v-model="payload.plan_id"
                :reduce="(e) => e.value"
                placeholder="Select/Type Here..."
                class="w-md-auto"
                disabled="disabled"
              />&ndash;&gt;
              </div>
              <div class="col-md-6 col-md-3">
                <label>GL Type</label>
                <v-select
                  :options="typeOf"
                  v-model="payload.budget_type"
                  placeholder="Select/Type Here..."
                  name="type"
                  class="w-md-auto"
                  @input="changeGLNew($event)"
                  :disabled="isUsedIM"
                />
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>GL Number</label>
                <v-select
                  :options="listGLNumber"
                  v-model="payload.gl_id"
                  :reduce="(e) => e.id"
                  placeholder="Select/Type Here..."
                  @input="selectedFund($event, '', payload.budget_type)"
                  class="w-md-auto"
                  :disabled="isUsedIM"
                />
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>Budget Task</label>
                <span v-if="optionsBudgetTaskSelected === 'New Budget Task'">
                  <input type="text" class="form-control" v-model="payload.budget_task_name" name="budget_task_name" />
                </span>
                <span v-else>
                  <v-select
                    v-model="payload.code_plan_budget"
                    :options="listBudgetTask"
                    :reduce="(e) => e.code"
                    label="name"
                    placeholder="Select Budget Task"
                    class="w-md-auto"
                    @input="selectedTask($event)"
                    :disabled="isUsedIM"
                  />
                </span>
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>Month</label>
                <v-select :options="monthData" label="label" :reduce="(e) => e.value" v-model="payload.month" :disabled="isUsedIM"></v-select>
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>Internal Memo Value</label>
                <RupiahInput
                  name="relocate_value"
                  v-model="payload.relocate_value"
                  v-validate="'numeric|max_value:999999999999999'"
                  @input="handleInputRelocateValue"
                />
                <FieldError name="relocate_value" label="Relocation Value" :errorBags="errors" />
                <span class="text-sm text-danger" v-show="isValidPOValue"> the Internal Memo Value cannot be smaller than the Used IM Value </span>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosIns from '@/api/axios';
import { formatCurrency } from '@/utils/formatNumber';
import moment from 'moment';
import RupiahInput from '@/components/helpers/rupiahInput.vue';
import FieldError from '@/components/helpers/fieldError.vue';

export default {
  components: { FieldError, RupiahInput },
  props: {
    detail: [],
    rowData: [],
  },
  data() {
    return {
      imCategory: '',
      isLoading: true,
      logData: {},
      comparisonData: {},
    };
  },
  mounted() {
    this.isLoading = false;
    console.log('', this.rowData);
  },
  methods: {
    async showModal() {
      //await this.fetchHistoricalLog();
    },
    resetModal() {
      this.logData = {};
      this.comparisonData = {};
      this.isLoading = true;
    },

    formatDate(date, withTime = true) {
      if (withTime) {
        return date ? moment(date).format('DD MMMM YYYY HH:mm') : '-';
      }
      return date ? moment(date).format('DD MMMM YYYY') : '-';
    },
    formatCurrency(value) {
      return formatCurrency(value, 'Rp.') || '-';
    },
  },
};
</script>

<style>
.skeleton-loader {
  background-color: #e0e0e0;
  height: 20px;
  margin-bottom: 10px;
  border-radius: 4px;
}
</style>
